import { Field, SystemFieldsExcluder } from './types';

export default class PimcoreSystemFieldsExcluder implements SystemFieldsExcluder {
  private PIMCORE_SYSTEM_FIELDS: string[] = [
    '_siblings', 'children', 'childrenSortBy', 'parent',
    'classname', 'index', 'filterDefinition', 'properties',
  ];

  constructor(systemFields?: string[]) {
    if (systemFields) {
      this.PIMCORE_SYSTEM_FIELDS = systemFields;
    }
  }

  excludeSystemFieldsFrom<T extends Field>(fields: T[]) {
    if (!Array.isArray(fields)) return [];
    return fields.filter((field) => !this.PIMCORE_SYSTEM_FIELDS.includes(field.name));
  }
}
